import DLL from '@visma/formula/lib/dll';
import { IntlProvider } from 'react-intl';
import Messages from '../lang/messages.fi.json';
import React from 'react';
import '../css/formula.scss';

const FormulaComponent = ({
  formId,
  formResponseId,
  formulaUrl,
  accessToken,
  reviewForm,
  credentials,
}) => {
  let review = reviewForm;

  const config = DLL.useAtomicForm(formId);
  if (review) {
    review =
      config?.meta?.allowEditAnswers === undefined
        ? true
        : !config?.meta?.allowEditAnswers;
  }
  const forceReview = review === undefined ? false : review;
  return (
    <div className="formula-canvas">
      <div className="form-inner">
        <IntlProvider locale="fi-FI" messages={Messages}>
          <DLL.Form
            axios={(axios) => {
              axios.defaults.baseURL = formulaUrl + "/api";
              if (accessToken) {
                axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
              } else {
                delete axios.defaults.headers.common.Authorization;
              }
            }}
            layer={0}
            forceReview={forceReview}
            credentials={credentials}
            id={
              formId.includes('latest')
                ? `fm_${config._id}_${config._rev}`
                : formId
            }
            dataId={formResponseId}
            fillProps={{
              disableResetFormdata: true,
            }}
            reviewProps={{
              showSuccessText: forceReview === false,
              highlightSuccessText: true,
            }}
          />
        </IntlProvider>
      </div>
    </div>
  );
};

export default FormulaComponent;
